import {downloadBlobAsFile} from '@Utils/file.util';
import {dispatchAiChatAssetDownloaded} from '@Components/ai-chat-window/lib/ai-chat-asset-downloaded.library';

export function isBesidePdfPage(target: EventTarget, mediaContainer: HTMLElement | null): boolean {
  if (!(target instanceof Node) || !mediaContainer?.contains(target)) {
    return false;
  }

  return !(target instanceof HTMLCanvasElement);
}

export function resolveDocumentTitle(title?: string): string {
  if (title !== undefined && title !== '') {
    return title;
  }

  return window.i18next.t('pmwjs_pdf_document');
}

export async function downloadPdf(url: string, title?: string, chatId?: string): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }
  const blob = await response.blob();

  downloadBlobAsFile(blob, `${resolveDocumentTitle(title)}.pdf`);
  if (chatId !== undefined) {
    dispatchAiChatAssetDownloaded(chatId);
  }
}
